module.exports = __webpack_public_path__ + "img/inst-modal-12.48b3c01b.png";